var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import Table from '../../../components/Table';
import history from 'helpers/History';
import { t } from '../../../helpers/i18n';
var OtasTable = /** @class */ (function (_super) {
    __extends(OtasTable, _super);
    function OtasTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            console.log('value: ', value);
            history.push("/otas/".concat(value.nameOta.toLowerCase()));
        };
        _this.handleCreate = function () {
            history.push('/otas/create');
        };
        return _this;
    }
    OtasTable.prototype.render = function () {
        var user = this.props.store.users.user;
        var data = this.props.otas.map(function (ota) {
            return __assign(__assign({ status: ota.disabled_at ? t('disabled') : t('enabled') }, ota), { webhook: "".concat(process.env.REACT_APP_SERVER).concat(ota.nameOta, "/").concat(user.client, "/$$apiToken$$") });
        });
        var headers = ['nameOta', 'description', 'status'];
        var filters = [
            {
                name: 'enabled',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
            {
                name: 'all',
                filter: function (item) { return true; }
            }
        ];
        return (React.createElement(Table, { items: data, header: headers, filters: filters, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); } }));
    };
    OtasTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.otaStore.read().then(function (otas) { return ({ otas: otas }); })
            ];
        }),
        observer
    ], OtasTable);
    return OtasTable;
}(Component));
export default OtasTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Otas/containers/OtasTable.tsx
// module id = 1592
// module chunks = 0